var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouseRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 9.29973V4.99973C19 4.44973 18.55 3.99973 18 3.99973H17C16.45 3.99973 16 4.44973 16 4.99973V6.59973L12.67 3.59973C12.29 3.25973 11.71 3.25973 11.33 3.59973L2.96998 11.1297C2.62998 11.4297 2.83998 11.9997 3.29998 11.9997H4.99998V18.9997C4.99998 19.5497 5.44998 19.9997 5.99998 19.9997H8.99998C9.54998 19.9997 9.99998 19.5497 9.99998 18.9997V13.9997H14V18.9997C14 19.5497 14.45 19.9997 15 19.9997H18C18.55 19.9997 19 19.5497 19 18.9997V11.9997H20.7C21.16 11.9997 21.38 11.4297 21.03 11.1297L19 9.29973ZM9.99998 9.99973C9.99998 8.89973 10.9 7.99973 12 7.99973C13.1 7.99973 14 8.89973 14 9.99973H9.99998Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseRounded);
export default __webpack_public_path__ + "static/media/HouseRounded.91fad1cf435d4f5c2e6eaafae10f8a92.svg";
export { ForwardRef as ReactComponent };